export default "__VITE_ASSET__CteUSEJI__"